import React from 'react';

const SvgWhoopsIcon = () => (
    <svg width="70" height="89" viewBox="0 0 70 89" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.271484" y="79.5012" width="69.458" height="9.26107" rx="1" fill="url(#paint0_linear_685_1533)"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M29.5144 18.1466H38.8712L59.6303 79.5011H10.6006L29.5144 18.1466Z" fill="url(#paint1_linear_685_1533)"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M19.16 51.7179L22.0149 42.4569H47.0912L50.2246 51.7179H19.16ZM13.4502 70.2401L16.3051 60.979H53.3581L56.4915 70.2401H13.4502Z" fill="url(#paint2_linear_685_1533)"/>
        <path d="M26.3796 7.34672C25.4744 6.1398 25.4996 4.58085 25.6253 3.95225C26.0029 2.82077 27.5107 3.95225 30.528 4.70657C33.5453 5.46089 35.4311 3.19792 35.8083 2.82076C36.1855 2.44359 37.317 0.18061 40.7114 0.934938C44.1059 1.68927 42.5972 4.70658 41.4658 8.10105C40.3343 11.4955 38.0713 14.1357 33.5453 14.1357C29.0193 14.1357 27.5111 8.85538 26.3796 7.34672Z" fill="#D9D9D9"/>
        <path d="M34.236 7.3467C33.3308 6.13977 29.5843 5.83804 27.8242 5.83804C28.5785 12.627 34.236 10.7412 34.6132 10.364C34.9903 9.98685 35.3675 8.85535 34.236 7.3467Z" fill="#43A0A1"/>
        <path d="M44.0425 6.59239C44.3442 5.98893 42.911 5.08374 42.1567 4.70657L41.4023 6.96956C42.1567 7.09528 43.7408 7.19585 44.0425 6.59239Z" fill="#F4AE4D"/>
        <ellipse cx="40.8474" cy="4.45066" rx="0.754328" ry="1.13149" transform="rotate(10.7953 40.8474 4.45066)" fill="#595956"/>
        <rect x="33.1045" y="13.0042" width="0.754328" height="5.28029" fill="#D9D9D9"/>
        <rect x="34.6133" y="13.0042" width="0.754328" height="5.28029" fill="#D9D9D9"/>
        <defs>
            <linearGradient id="paint0_linear_685_1533" x1="0.271484" y1="84.1317" x2="69.7295" y2="84.1317" gradientUnits="userSpaceOnUse">
                <stop stopColor="#EEEEEE"/>
                <stop offset="1" stopColor="#B8B8B8"/>
            </linearGradient>
            <linearGradient id="paint1_linear_685_1533" x1="13.7162" y1="46.5993" x2="63.4943" y2="46.5993" gradientUnits="userSpaceOnUse">
                <stop offset="0.4" stopColor="#D9D9D9"/>
                <stop offset="1" stopColor="#737373"/>
            </linearGradient>
            <linearGradient id="paint2_linear_685_1533" x1="17" y1="58.486" x2="51" y2="58.486" gradientUnits="userSpaceOnUse">
                <stop stopColor="white"/>
                <stop offset="1" stopColor="#DDDDDD"/>
            </linearGradient>
        </defs>
    </svg>

);

export default SvgWhoopsIcon;
